import React, { useCallback, useMemo, useEffect, useRef, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import {
  Box,
  Button,
  IconButton,
  Typography,
  Tooltip,
} from '@mui/material';
import { Form, Container, Row, Col } from "react-bootstrap";
import Axios from '../../lib/axios/axiosInstance';
import { Slide, toast } from 'react-toastify';
import { Delete, Print, Download, List } from '@mui/icons-material';
import Modal from 'react-bootstrap/Modal';
import { useNavigate, Link, useParams, useSearchParams } from "react-router-dom";
import CustomTableForModal from './CustomTableForModal';
import * as AuthVerify from '../../lib/common';

const CustomTable = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [catalogDetails, setCatalogDetails] = useState(false);
  const [data, setData] = useState([]);
  const [eData, setEData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [iseLoading, setEIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [eRowCount, setERowCount] = useState(0);
  const [emShow, setEmShow] = useState(false);
  const [dmShow, setDmShow] = useState(false);
  const selectedMatnum = useRef(false);
  const showModal = useRef(false);

  const contractData = useRef(false);
  const [editPermission, setEditPermission] = useState(false);

  const [columnFilters, setColumnFilters] = useState([]);
  const [eColumnFilters, setEColumnFilters] = useState([]);
  const [columnFilterFns, setColumnFilterFns] = useState({
    sellingprice: 'equals',
    matname: 'contains',
    contractprice: 'equals',
  });
  const [eColumnFilterFns, setEColumnFilterFns] = useState({
    sellingprice: 'equals',
    matname: 'contains',
    contractprice: 'equals',
    matnum: 'contains'
  });
  const [globalFilter, setGlobalFilter] = useState('');
  const [eGlobalFilter, setEGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const [eSorting, setESorting] = useState([]);
  const tableInstanceRef = useRef(null);
  const eTableInstanceRef = useRef(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5
  });
  const [ePagination, setEPagination] = useState({
    pageIndex: 0,
    pageSize: 10
  });

  useEffect(async () => {
    setEditPermission(AuthVerify.getPermissions("Catalog")?.edit);
  }, [searchParams])

  const handleDeleteRow = useCallback(
    (row) => {
      setDmShow(false);
      if (!row) row = selectedMatnum.current;
      if (!row) return;
      deleteHandler();
    },
    [data],
  );

  const findFilterCondition = (name) => {
    var condition = '';
    if (columnFilterFns[name]) {
      condition = columnFilterFns[name];
    }
    // if(condition==''){
    //   condition = initialColumnFiltersFns[name];
    // }
    return condition;
  }

  const fetchDataFromAPI = async (reset = false) => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }

    let filterQuery = '';
    let sorterQuery = '';

    if (!reset) {
      if (columnFilters.length > 0) {
        columnFilters.forEach(element => {
          filterQuery += `&filter=${element.id},${findFilterCondition(element.id)},${element.value}`;
        });
      }
      if (sorting.length > 0) {
        sorting.forEach(element => {
          sorterQuery += `&sortby=${element.id}&orderby=${element.desc ? 'desc' : 'asc'}`;
        });
      }
    } else {
      setPagination({
        pageIndex: 0,
        pageSize: 5
      });
      tableInstanceRef.current.resetRowSelection();
    }

    const user = AuthVerify.getUser();
    const catalognum = searchParams.get("catalognum")
    let url = `/corporate/catalog/${user.arnum}/${catalognum}?limit=${pagination.pageSize}&offset=${pagination.pageIndex * pagination.pageSize}${sorterQuery}${filterQuery}`;
    await Axios.get(url)
      .then(function (response) {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
        if (response && response.data?.data) {
          setCatalogDetails(response.data?.data.catalog)
          setData(response.data?.data.items.items ?? []);
          setRowCount(response.data?.data.items.count);
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        // navigate('/');
      });
  };

  const getNewCartItemsFromList = async (reset = false) => {
    // showModal.current=true;
    // if (!eData.length) {
    //   setEIsLoading(true);
    // } else {
    //   setIsRefetching(true);
    // }

    // let filterQuery = '';
    // let sorterQuery = '';

    // if (!reset) {
    //   if (eColumnFilters.length > 0) {
    //     eColumnFilters.forEach(element => {
    //       filterQuery += `&filter=${element.id},${findFilterCondition(element.id)},${element.value}`;
    //     });
    //   }
    //   if (eSorting.length > 0) {
    //     eSorting.forEach(element => {
    //       sorterQuery += `&sortby=${element.id}&orderby=${element.desc ? 'desc' : 'asc'}`;
    //     });
    //   }
    // } else {
    //   setEPagination({
    //     pageIndex: 0,
    //     pageSize: 10
    //   });
    //   if(eTableInstanceRef.current)eTableInstanceRef.current.resetRowSelection();
    // }

    // const user = AuthVerify.getUser();
    // const catalognum = searchParams.get("catalognum")
    // let url = `/corporate/catalog/${user.arnum}/${catalognum}/${contractData.current?'newcontractitem':'new'}?limit=${ePagination.pageSize}&offset=${ePagination.pageIndex * ePagination.pageSize}${sorterQuery}${filterQuery}`;
    // await Axios.get(url)
    //   .then(function (response) {
    //     setIsError(false);
    //     setEIsLoading(false);
    //     setIsRefetching(false);
    //     if (response && response.data?.data) {
    //       setEmShow(true);
    //       setEData(response.data?.data.items.items ?? []);
    //       setERowCount(response.data?.data.items.count);
    //     }
    //     else {
    //       toast.error(response.statusText ?? "Data fetching failed !", {
    //         position: toast.POSITION.TOP_CENTER,
    //         autoClose: 3000,
    //         transition: Slide,
    //       });
    //     }
    //   })
    //   .catch(function (error) {
    //     // navigate('/');
    //   });
    setEmShow(true);
  };
  const updateDataList = (response) =>{
    // setData(response.data?.data?.items.slice(0,ePagination.pageSize));
    setData(response.data?.data?.items??[]);
    setRowCount(response.data?.data?.items.length);
  }

  // Add New Catalog Item
  // https://devb2b.bizpoint-intl.com:3082/api/corporate/catalog/:arnum/:catalog/newitem
  const addNewCartItemsFromList = async (rows) => {
    const arnum=AuthVerify.getUser().arnum;
    const catalognum=catalogDetails.catalognum;
    var data={item: []}
    rows.forEach(item=>{
        data.item.push({matnum:item.original.matnum});
    })
    await Axios.post(`/corporate/catalog/${arnum}/${catalognum}/newitem`,data)
    .then(function (response) {
        if (response && response.data?.data?.items) {
            setData(response.data?.data?.items ? response.data?.data?.items.slice(0,ePagination.pageSize):[]);
            setRowCount(response.data?.data?.items.length);
            setEmShow(false);
            toast.success('Item added successfully', {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
            });
        }
        else {
          toast.error(response.statusText??"Data fetching failed !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
    })
    .catch(function (error) {
      navigate('/');
    });
  };

  useEffect(() => {
    fetchDataFromAPI();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting
  ]);

  // useEffect(() => {
  //   if(showModal.current==true)getNewCartItemsFromList();
  // }, [
  //   eColumnFilters,
  //   eGlobalFilter,
  //   ePagination.pageIndex,
  //   ePagination.pageSize,
  //   eSorting
  // ]);

  const deleteHandler = async () => {
    setIsLoading(true);
    const arnum = AuthVerify.getUser().arnum;
    const catalognum = searchParams.get("catalognum")
    await Axios.delete(`/corporate/catalog/${arnum}/${catalognum}/${selectedMatnum.current}`)
      .then(function (response) {
        setIsLoading(false);
        setIsError(false);
        setIsRefetching(false);
        if (response && response.data?.data) {
          // setCatalogDetails(response.data?.data.catalog)
          setData([]);
          setRowCount(0);
          fetchDataFromAPI();
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        // navigate('/');
      });
  }

  const columns = useMemo(
    () => [
      {
        accessorFn: (row) => row.imageurl,
        id: 'imageurl',
        enableColumnFilter: false,
        enableSorting: false,
        enableColumnFilterModes: false,
        header: 'Product',
        enableEditing: false,
        size: 50,
        Cell: ({ cell, row }) => (
          <a href="#">
            <img style={{ maxHeight: "60px" }} src={AuthVerify.getImageLink(cell.getValue())} alt="Product" />
          </a>
          // <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'matnum',
        header: "Product Code",
        Cell: ({ cell, row }) => (
          <>
            <p className="product-name">
              <Link to={"/product-detail?matnum=" + cell.getValue()}>{cell.getValue()}</Link>
            </p>
            {/* <Typography variant='h4'>Matnum: {cell.getValue()}</Typography> */}
          </>

        ),
        size: 100,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'matname',
        header: "Description",
        Cell: ({ cell, row }) => (
            <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size: 100,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'contractprice',
        header: "Contract price",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size: 50,
        enableColumnFilterModes: true,
        filterFn: 'equals',
        columnFilterModeOptions: ['equals', 'lessThan', 'greaterThan'],
      },
      {
        accessorKey: 'sellingprice',
        header: "Selling Price",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size: 50,
        enableColumnFilterModes: true,
        filterFn: 'equals',
        columnFilterModeOptions: ['equals', 'lessThan', 'greaterThan'],
      }
      //end
    ],
    [],
  );

  return (
    <>
      {catalogDetails && <Row style={{ margin: "auto" }}>
        <h2>Catalog Details</h2>
        <h5><strong>Catalog ID {catalogDetails?.catalognum}</strong></h5>
        <h5><strong>Name:</strong> {catalogDetails?.catalogname}</h5>
        {/* <h5><strong>Arnum:</strong> {catalogDetails?.arnum}</h5> */}
        {/* <div className="order-detail-content table-responsive" style={{width:"auto"}}> */}
        <Col sm={12} style={{ padding: "5px 0px 10px 0px" }}>
          {/* <Link to="#" style={{ float: "left", textDecoration: "none", fontWeight: "bold" }}>Import CSV</Link> */}
          {editPermission && <>
            <button style={{ float: "right", textDecoration: "none", marginLeft: "20px", fontWeight: "bold", background: "none", color: "#1890ff" }} onClick={() => { contractData.current=false; getNewCartItemsFromList(true); }}>+ Add From Product</button>
            <button style={{ float: "right", textDecoration: "none", marginLeft: "20px", fontWeight: "bold", background: "none", color: "#1890ff" }} onClick={() => { contractData.current=true; getNewCartItemsFromList(true); }}>+ Add From Contract</button>
          </>}
        </Col>
      </Row>}
      <MaterialReactTable
        columns={columns}
        data={data}
        enableColumnActions={false}
        enableGlobalFilter={false}
        enableColumnFilterModes
        initialState={{
          showColumnFilters: true
        }}
        manualFiltering
        manualPagination
        manualSorting
        onColumnFilterFnsChange={setColumnFilterFns}
        onColumnFiltersChange={setColumnFilters}
        onGlobalFilterChange={setGlobalFilter}
        onPaginationChange={setPagination}
        onSortingChange={setSorting}
        tableInstanceRef={tableInstanceRef}
        rowCount={rowCount}
        enableEditing
        state={{
          columnFilters,
          columnFilterFns,
          globalFilter,
          isLoading,
          pagination,
          showAlertBanner: isError,
          showProgressBars: isRefetching,
          sorting,
        }}
        positionActionsColumn="last"
        displayColumnDefOptions={{
          'mrt-row-actions': {
            header: 'Action', //change header text
          },
        }}
        renderRowActions={({ row, table }) => (
          <Box sx={{ display: 'flex', gap: '1rem' }}>
            <Tooltip arrow placement="left" title="Print">
              <IconButton onClick={() => console.log(row)}>
                <Print />
              </IconButton>
            </Tooltip>
            <Tooltip arrow placement="right" title="Export">
              <IconButton color="error" onClick={() => console.log(row)}>
                <Download />
              </IconButton>
            </Tooltip>
            {editPermission &&
              <Tooltip arrow placement="right" title="Delete">
                <IconButton color="error" onClick={() => { selectedMatnum.current = row.original.matnum; setDmShow(true) }}>
                  <Delete />
                </IconButton>
              </Tooltip>}
          </Box>
        )}
        muiTableHeadCellProps={{
          sx: {
            // fontWeight: 'bold',
            fontSize: '15px',
          },
        }}
        muiTablePaginationProps={{
          sx: {
            fontWeight: 'bold',
            paddingTop: '12px',
            fontSize: '16px',
          },
        }}
        muiTableBodyCellEditTextFieldProps={({ cell, column, row, table }) => ({
          sx: {
            fontSize: '17px'
          },
        })}
        muiTableHeadCellFilterTextFieldProps={{
          sx: {
            fontWeight: 'bold',
            fontSize: '17px',
          },
        }}
      />

      <Modal show={emShow} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={() => setEmShow(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Create New Catalog</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CustomTableForModal contractData={contractData} updateDataList={updateDataList} catalogDetails={catalogDetails}/>
          {/* <MaterialReactTable
            columns={columns}
            data={eData}
            enableColumnActions={false}
            enableGlobalFilter={false}
            enableColumnFilterModes
            initialState={{
              showColumnFilters: true
            }}
            manualFiltering
            manualSorting
            onColumnFilterFnsChange={setEColumnFilterFns}
            onColumnFiltersChange={setEColumnFilters}
            onGlobalFilterChange={setEGlobalFilter}
            onPaginationChange={setEPagination}
            onSortingChange={setESorting}
            tableInstanceRef={eTableInstanceRef}
            rowCount={eRowCount}
            state={{
              eColumnFilters,
              eColumnFilterFns,
              eGlobalFilter,
              iseLoading,
              ePagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              eSorting,
            }}
            enableRowSelection
            renderTopToolbarCustomActions={({ row, table }) => (
              <Box
                sx={{ display: 'flex', gap: '0.5rem', p: '0.5rem', flexWrap: 'wrap' }}
              >
                <Button
                  disabled={
                    !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                  }
                  // onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                  onClick={() => addNewCartItemsFromList(table.getSelectedRowModel().rows)}
                  startIcon={<List />}
                  variant="contained"
                  color="primary"
                >
                  Add to my catalog
                </Button>
              </Box>
            )}
            positionActionsColumn="last"
            muiTableHeadCellProps={{
              sx: {
                // fontWeight: 'bold',
                fontSize: '15px',
              },
            }}
            muiTablePaginationProps={{
              sx: {
                fontWeight: 'bold',
                paddingTop: '12px',
                fontSize: '16px',
              },
            }}
            muiTableBodyCellEditTextFieldProps={({ cell, column, row, table }) => ({
              sx: {
                fontSize: '17px'
              },
            })}
            muiTableHeadCellFilterTextFieldProps={{
              sx: {
                fontWeight: 'bold',
                fontSize: '17px',
              },
            }}
          /> */}
          {/* <button className="button" title="Proceed to Checkout" type="button" onClick={()=>addNewCartItemsFromList()}><span>Add to my catalog</span></button> */}
        </Modal.Body>
      </Modal>

      <Modal show={dmShow} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={() => setDmShow(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure about the delete ?
        </Modal.Body>
        <Modal.Footer>
          <button
            className="button btn-primary"
            title="Proceed to Checkout"
            type="button"
            onClick={() => handleDeleteRow()}
            style={{
              marginRight: "10px",
              padding: "10px"
            }}
          >
            <span>Confirm</span>
          </button>
          <button
            className="button btn-danger"
            title="Proceed to Checkout"
            type="button"
            onClick={() => setDmShow(false)}
            style={{
              marginRight: "10px",
              padding: "10px"
            }}
          >
            <span>Close</span>
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomTable;
